import { render, staticRenderFns } from "./CustomMiddleCard.vue?vue&type=template&id=f6e38a40&scoped=true"
import script from "./CustomMiddleCard.vue?vue&type=script&lang=js"
export * from "./CustomMiddleCard.vue?vue&type=script&lang=js"
import style0 from "./CustomMiddleCard.vue?vue&type=style&index=0&id=f6e38a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e38a40",
  null
  
)

export default component.exports